import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {"display":"block"},
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "var(--fill-0, white)",
      "fill-opacity": ".5",
      "fill-rule": "evenodd",
      d: "M14.544 14.4 9.426 6.94l.008.007L14.05 1.6h-1.542l-3.76 4.352L5.763 1.6H1.718l4.778 6.965-5.04 5.835h1.542l4.18-4.842 3.321 4.842zM5.151 2.764l7.182 10.472H11.11L3.923 2.764z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }